<template>
<v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <v-snackbar
      v-model="alert"
      :timeout="2000"
      color="error"
      top
    >
    <v-icon>mdi-alert</v-icon>
      &nbsp;&nbsp;您没有访问权限，系统将会跳转。
     </v-snackbar>
   <v-data-table
    :headers="headers"
    :items="items"
    sort-by="name"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>预定模板</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              v-show="isAdmin"
            >新建</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-autocomplete v-model="editedItem.bookingTypeIdentity" label="预定模板" :items="bookingTypes"  item-text="Name" item-value="Identity"></v-autocomplete>
                  <!--  <v-text-field v-model="editedItem.bookingTypeIdentity" label="预定模板"></v-text-field> -->
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.name" label="模板名称"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" md="4">
                  <!--  <v-text-field v-model="editedItem.startDate" label="开始日期"></v-text-field> -->
                       <v-menu
                          v-model="startMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.startDate"
                              label="开始日期"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.startDate" @input="startMenu = false" locale="zh-cn"></v-date-picker>
                        </v-menu>
                  </v-col>
                   <v-col cols="12" sm="5" md="4">
                  <!--  <v-text-field v-model="editedItem.endDate" label="结束日期"></v-text-field> -->
                    <v-menu
                          v-model="endMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.endDate"
                              label="开始日期"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.endDate" @input="endMenu = false" locale="zh-cn"></v-date-picker>
                        </v-menu>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-checkbox
                        v-model="editedItem.excludeWeekend"
                        label="跳过周末"
                      ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                   <v-autocomplete v-model="editedItem.slotPattern" label="时间槽模板" :items="eventSlotPatterns"  item-text="Name" item-value="Identity" multiple></v-autocomplete>

                  <!--  <v-text-field v-model="editedItem.slotPattern" label="时间槽模板"></v-text-field> -->
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                  <v-autocomplete v-model="editedItem.formStyle" label="表单模板" :items="FormStyles"  item-text="Name" item-value="Identity"></v-autocomplete>

                <!--    <v-text-field v-model="editedItem.formStyle" label="表单模板"></v-text-field>-->
                  </v-col>
                 
                   <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model.number="editedItem.daysInAdvance" label="最多提前天数"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model.number="editedItem.minDaysInAdvance" label="最少提前天数"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model.number="editedItem.refreshHours" label="刷新时间（分钟）"></v-text-field>
                  </v-col>
      
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                   <v-autocomplete @change="search = ''" v-model="editedItem.bookPermission" label="预定权限组" :items="permissionGroup" return-object item-text="Name" item-value="Identity" multiple></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                   <v-autocomplete @change="search = ''" v-model="editedItem.managePermission" label="管理权限组" :items="permissionGroup" return-object item-text="Name" item-value="Identity" multiple></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.icon" label="图标"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.websiteIdentity" label="所属页面"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.iconAvailable" label="按钮图标（可用）"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.iconFull" label="按钮图标（已满）"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="close">取消</v-btn>
              <v-btn color="green darken-1" text @click="save">保存</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.slotPattern="{item}">
      {{ eventSlotPatterns.filter(x=>item.slotPattern.indexOf(x.Identity)!=-1).length }}
    </template>
    <template v-slot:item.formStyle="{item}">
      {{ FormStyles.find(x=>x.Identity==item.formStyle).Name }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">重新加载</v-btn>
    </template>
  </v-data-table>
</v-container>
</template>

<script>
import {eventTemplateService} from '@/api/event-template.service';
import moment from 'moment';
import { mapGetters } from "vuex";

export default {
    name:'eventTempalte',
    data: () => ({
      dialog: false,
      headers: [
        { text: '模板名称', value: 'name'},
        { text: '开始日期', value: 'startDate' },
        { text: '结束日期', value: 'endDate' },
        { text: '绑定时间槽个数', value: 'slotPattern' },
        { text: '表单模板', value: 'formStyle'},
        { text: '操作', value: 'actions', sortable: false },
      ],
      items: [],
      editedIndex: -1,
      editedItem: {
        bookingTypeIdentity:'',
        name: '',
        startDate: '',
        endDate: '',
        slotPattern : '',
        formStyle : '',
        excludeWeekend: false,
        icon: '',
        iconAvailable: '',
        iconFull:'',
        managePermission: [],
        bookPermission: [],
        daysInAdvance: 0,
        minDaysInAdvance: 0,
        websiteIdentity: '',
        refreshHours: 0
      },
      defaultItem: {
        bookingTypeIdentity:'',
        name: '',
        startDate: '',
        endDate: '',
        slotPattern : '',
        formStyle : '',
        excludeWeekend: false,
        icon: '',
        iconAvailable: '',
        iconFull:'',
        managePermission: [],
        bookPermission: [],
        daysInAdvance: 0,
        minDaysInAdvance: 0,
        websiteIdentity: '',
        refreshHours: 0
      },
      isLoading: false,
      alert:false,
      startMenu: false,
      endMenu: false,
      isAdmin: true
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? '新建模板' : '编辑模板'
      },
      ...mapGetters(["bookingTypes","eventSlotPatterns","FormStyles", "permissionGroup", "userProfile"])
    },

    async mounted(){
    
      this.isLoading = true;

       if (!this.userProfile)
            await this.$store.dispatch('getUserProfile'); 
       
        if (this.userProfile.UserGroups.filter(x=>x.Name==="Administrators").length === 0)
        {
              this.isAdmin = false;
              //this.alert = true;
              //setTimeout(()=>this.$router.push('/'),2000);
              //return;
        }

      let templates = await eventTemplateService.getEventTemplates(true);

      if (templates.length === 0 && this.isAdmin == false)
      {
             this.alert = true;
             setTimeout(()=>this.$router.push('/'),2000);
             return;
      }

      //console.log("Type "+this.bookingTypes);
      if (!this.bookingTypes || this.bookingTypes.length === 0)
          await this.$store.dispatch('getBookingType');
      
      if (!this.eventSlotPatterns || this.eventSlotPatterns.length === 0 )
          await this.$store.dispatch('getEventSlotPattern');
      
      if (!this.formStyle || this.formStyle.length === 0)
          await this.$store.dispatch('getFormStyle');
      
      if (!this.permissionGroup || this.permissionGroup.length === 0)
        await this.$store.dispatch('getPermissionGroup');

      this.isLoading = false;

      this.items = templates.map(o=>({
        identity: o.Identity,
        bookingTypeIdentity : o.BookingTypeIdentity,
        name : o.Name,
        startDate : moment(o.StartDate).format('YYYY-MM-DD'),
        endDate : moment(o.EndDate).format('YYYY-MM-DD'),
        slotPattern : o.EventSlotPatternIdentity,
        formStyle : o.FormStyleIdentity,
        excludeWeekend: o.ExcludeWeekend,
        icon: o.Icon,
        iconAvailable: o.IconAvailable,
        iconFull: o.IconFull,
        managePermission: o.ManagePermission,
        bookPermission: o.BookPermission,
        daysInAdvance: o.DaysInAdvance,
        minDaysInAdvance: o.MinDaysInAdvance,
        websiteIdentity: o.WebsiteIdentity,
        refreshHours: o.RefreshHours
      }));
    
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.items = []
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.items.indexOf(item)
        confirm('您确认要删除该项吗？') && this.del(item, index);
      },

      async del(item, index){
        this.items.splice(index, 1);
        this.isLoading = true;
        await this.$store.dispatch('delEventTemplate', item.identity);
        this.isLoading = false;
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        if (this.editedIndex > -1) {
          Object.assign(this.items[this.editedIndex], this.editedItem);

          this.isLoading = true;
          this.close();
          let payload = {
            Identity: this.editedItem.identity,
            Name: this.editedItem.name,
            BookingTypeIdentity: this.editedItem.bookingTypeIdentity,
            StartDate: this.editedItem.startDate,
            EndDate: this.editedItem.endDate,
            FormStyleIdentity: this.editedItem.formStyle,
            EventSlotPatternIdentity: this.editedItem.slotPattern,
            ExcludeWeekend: this.editedItem.excludeWeekend,
            Icon: this.editedItem.icon,
            IconAvailable: this.editedItem.iconAvailable,
            IconFull: this.editedItem.iconFull,
            ManagePermission: this.editedItem.managePermission,
            BookPermission: this.editedItem.bookPermission,
            DaysInAdvance: this.editedItem.daysInAdvance,
            MinDaysInAdvance: this.editedItem.minDaysInAdvance,
            WebsiteIdentity: this.editedItem.websiteIdentity,
            RefreshHours: this.editedItem.refreshHours
          };
          await this.$store.dispatch('patchEventTemplate', payload);
          this.isLoading = false;

        } else {
          
          this.isLoading = true;

          this.close();

          let payload = {
            Name: this.editedItem.name,
            BookingTypeIdentity: this.editedItem.bookingTypeIdentity,
            StartDate: this.editedItem.startDate,
            EndDate: this.editedItem.endDate,
            FormStyleIdentity: this.editedItem.formStyle,
            EventSlotPatternIdentity: this.editedItem.slotPattern,
            ExcludeWeekend: this.editedItem.excludeWeekend,
            Icon: this.editedItem.icon,
            IconAvailable: this.editedItem.iconAvailable,
            IconFull: this.editedItem.iconFull,
            ManagePermission: this.editedItem.managePermission,
            BookPermission: this.editedItem.bookPermission,
            DaysInAdvance: this.editedItem.daysInAdvance,
            MinDaysInAdvance: this.editedItem.minDaysInAdvance,
            WebsiteIdentity: this.editedItem.websiteIdentity,
            RefreshHours: this.editedItem.refreshHours
          };
          await this.$store.dispatch('postEventTemplate', payload);
          this.isLoading = false;
          this.items.push(this.editedItem)
        }
        this.close()
      },
    },
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/management/EventTemplate.vue